// PaymentsTabs.tsx
import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Divider,
} from '@mui/material';
import { makeStyles } from '@material-ui/core';
import TopNav from '../components/common/TopNav';
import Container from '../components/Elements/Container';
import ComercialTable from './ComercialTable';
import TransfersTable from './TransfersTable';
import BillingTable from './BillingTable';
import SubscriptionsTable from './SuscriptionsTable';
import DowngradeApprovalsTable from './DowngradeApprovalsTable';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    background: '#f5f7fb',
  },
  pageHeader: {
    background: '#1f78b4',
    color: '#fff',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  backBtn: {
    color: '#fff !important',
    padding: 6,
  },
  pageTitleWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 1.1,
  },
  pageSubtitle: {
    opacity: 0.9,
    fontSize: 14,
  },
  content: {
    padding: 24,
  },
  card: {
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #e6e9ef',
  },
  tabsBar: {
    padding: '0 16px',
    background: '#f7f9fc',
  },
  tabsRoot: {
    minHeight: 48,
  },
  tabRoot: {
    minHeight: 48,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    padding: '12px 16px',
  },
  tabIndicator: {
    height: 3,
    background: '#1f78b4',
    borderRadius: 3,
  },
  sectionHeader: {
    background: '#1f78b4',
    color: '#fff',
    fontWeight: 700,
    padding: '12px 16px',
    fontSize: 14,
  },
  placeholder: {
    padding: 16,
  },
  footerSpacer: {
    height: 12,
    background: '#fff',
  },
}));

export default function StaffPanel() {
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);
  return (
    <>
      <TopNav titulo="Staff" subtitulo="| Panel" />
      <Container>
        <Box className={classes.root}>

          <Box className={classes.content}>
              <Box className={classes.tabsBar}>
                <Tabs
                  value={tab}
                  onChange={(_, v) => setTab(v)}
                  classes={{
                    root: classes.tabsRoot,
                    indicator: classes.tabIndicator,
                  }}
                  variant="scrollable"
                  scrollButtons={false}
                >
                  <Tab label="Comercial" classes={{ root: classes.tabRoot }} />
                  <Tab label="Transferencias" classes={{ root: classes.tabRoot }} />
                  <Tab label="Facturas" classes={{ root: classes.tabRoot }} />   
                  <Tab label="Suscripciones" classes={{ root: classes.tabRoot }} />
                  <Tab label="Aprobaciones de downgrade" classes={{ root: classes.tabRoot }} />
                </Tabs>
              </Box>
              <Divider />

              <Box className={classes.placeholder}>
                {tab === 0 && (
                  <Typography color="textSecondary">
                    <ComercialTable />
                  </Typography>
                )}
                {tab === 1 && (
                  <Typography color="textSecondary">
                    <TransfersTable />
                  </Typography>
                )}
                {tab === 2 && (
                  <Typography color="textSecondary">
                    <BillingTable />
                  </Typography>
                )}
                {tab === 3 && (
                  <Typography color="textSecondary">
                    <SubscriptionsTable />
                  </Typography>
                )}
                {tab === 4 && (
                  <Typography color="textSecondary">
                    <DowngradeApprovalsTable />
                  </Typography>
                )}
              </Box>
          
          </Box>
        </Box>
      </Container>
    </>
  );
}
